// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interventionSelectorItem{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0 2%}@media only screen and (min-device-width:320px) and (max-device-width:480px){.text-option{height:25px!important;text-align:center!important;line-height:1em!important;font-size:.75rem}.text-legend{line-height:1rem;font-size:.875rem;margin:1.5rem 0 .75rem 0!important;text-align:center}.p-dropdown{width:80%!important}}", ""]);
// Exports
module.exports = exports;
